module.exports = __webpack_public_path__ + "static/media/promo4.e0c206cf.jpg";